import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Params, RouterModule } from '@angular/router';
import { ErrorReportingService } from '../../services/error-reporting/error-reporting.service';

@Component({
  selector: 'app-button',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
  ],
  templateUrl: './button.component.html',
  styleUrl: './button.component.scss',
})
export class ButtonComponent implements OnInit {
  @Output() action = new EventEmitter<void>();
  @Input() context: string | null = null;
  @Input() disabled: boolean;
  @Input() href: string;
  @Input() icon: string | { name: string; position: 'start' | 'end'; };
  @Input({ required: true }) innerId: string;
  @Input() label: string;
  @Input() loading: boolean;
  @Input() queryParams: Params;
  @Input() rel = '';
  @Input() state: Record<string, unknown>;
  @Input() styleClass = 'primary';
  @Input() target = '_self';
  @Input() type: 'button' | 'submit' | 'reset' = 'button';
  iconConfig: { name: string; position: 'start' | 'end' } | null;
  internalLink = false;

  constructor(
    private errorReportingService: ErrorReportingService,
  ) {}

  ngOnInit(): void {
    this.initialize();
  }

  triggerAction(): void {
    if (this.disabled || this.loading) {
      return;
    }
    this.action?.emit();
  }

  private initialize(): void {
    if (this.href) {
      const [path, queryString] = this.href.split('?');
      this.internalLink = path.startsWith('/');
      if (this.internalLink && queryString) {
        this.href = path;
        try {
          const decodedQuery = decodeURIComponent(queryString);
          this.queryParams = decodedQuery.split('&').reduce<Record<string, string>>((acc, param) => {
            const [key, value] = param.split('=');
            acc[key] = value;
            return acc;
          }, {});
        } catch (error) {
          this.errorReportingService.log('ButtonComponent', 'decode-query-params', error);
        }
      }
    }
    if (typeof this.icon === 'string') {
      this.iconConfig = { name: this.icon, position: 'start' };
    } else {
      this.iconConfig = this.icon ?? null;
    }
  }
}
